module.exports = __webpack_public_path__ + "media/images/career_camp/2022/texts/find_your_magic-741971afc2f36a322dc2c4ec803dd20b.svg";